module.exports = "https://static.energy5.com/_next/static/images/lastStepImage-1e9768e4a41a384e4de80c9f875e7672.jpg";